<div class="multipoint-installation-pymes">
  <div class="multipoint-installation-pymes__header">
    <h2>{{ 'NEW_CONTRACTS.INSTALLATION_DATA.TITLE' | i18nextEager }}</h2>
    <span class="compulsory">* {{ 'COMMONS.REQUIRED' | i18nextEager }}</span>
  </div>
  <form [formGroup]="installationsForm">
    <ng-container formArrayName="installations">
      <ng-container *ngFor="let installationForm of installations.controls; let i = index">
        <section [formGroup]="installationForm">
          <div class="multipoint-installation-pymes__container-title">
            <h2 *ngIf="installationForm?.controls.name.value; else nameDefault">
              {{ installationForm?.controls.name.value }}
            </h2>
            <ng-template #nameDefault>
              <h2>{{ 'NEW_CONTRACTS.INSTALLATION_DATA.INSTALLATION' | i18nextEager }} {{ i + 1 }}</h2>
            </ng-template>
            <img
              *ngIf="installationForm.invalid"
              src="assets/icons/rejected-red.svg"
              alt="{{ 'NEW_CONTRACTS.REJECTED' | i18nextEager }}"
            />
            <div class="multipoint-installation-pymes__container-icons ">
              <div
                *ngIf="installationForm?.controls.sendedCRM.value && installationForm?.controls.registeredCRM.value"
                class="icon"
                [matTooltip]="'NEW_CONTRACTS.APPROVED' | i18nextEager"
                matTooltipPosition="above"
              >
                <img src="/assets/icons/approved.svg" alt="{{ 'NEW_CONTRACTS.APPROVED' | i18nextEager }}" />
              </div>
              <div
                *ngIf="installationForm?.controls.sendedCRM.value && !installationForm?.controls.registeredCRM.value"
                class="icon"
                [matTooltip]="installationForm?.controls.descriptionErrorRegisteredCRM.value"
                matTooltipPosition="above"
              >
                <img src="/assets/icons/rejected.svg" alt="{{ 'NEW_CONTRACTS.REJECTED' | i18nextEager }}" />
              </div>

              <div class="icon" *ngIf="i > 0 || installations.controls.length > 1">
                <img
                  src="/assets/icons/broom-red.svg"
                  alt="{{ 'NEW_CONTRACTS.CLEAR_FORM' | i18nextEager }}"
                  (click)="deleteInstallation(i)"
                />
              </div>
            </div>
          </div>

          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.INSTALLATION_DATA.INSTALLATION_NAME' | i18nextEager }}</mat-label>
            <input
              matInput
              formControlName="name"
              maxlength="40"
              [errorStateMatcher]="customErrorMatcher('required')"
            />
            <mat-error *ngIf="checkControlRequired(installationForm.get('name'))">
              {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label> {{ 'NEW_CONTRACTS.CUPS' | i18nextEager }}</mat-label>
            <input
              matInput
              formControlName="cups"
              maxlength="22"
              placeholder="cups"
              [errorStateMatcher]="customErrorMatcher('cups')"
            />
            <mat-error *ngIf="checkControlCups(installationForm.get('cups'))">
              {{ 'NEW_CONTRACTS.CUPS_ERROR_2' | i18nextEager }}
            </mat-error>
            <mat-error *ngIf="checkControlRequired(installationForm.get('cups'))">
              {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.CNAE' | i18nextEager }}</mat-label>
            <input matInput formControlName="cnae" numeric [maxlength]="isUserSpanish ? 4 : 5" />
            <mat-error
              *ngIf="
                (installationForm?.get('cnae').errors?.required ||
                installationForm?.get('cnae').errors?.invalid_cnae) &&
                (installationForm.get('cnae').touched || installationForm.get('cnae').dirty)
              "
            >
              {{ (isUserSpanish ? 'NEW_CONTRACTS.CNAE_ERROR' : 'NEW_CONTRACTS.PT_CNAE_ERROR') | i18nextEager }}
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="isUserSpanish">
            <mat-form-field
              *ngIf="hasTDOrTDVEString(installationForm.get('feeReal').value)"
              appearance="outline"
            >
              <mat-label> {{ 'NEW_CONTRACTS.ACCESS_RATE' | i18nextEager }} * </mat-label>
              <input matInput formControlName="feeReal" maxlength="22" placeholder="cups" readonly />
            </mat-form-field>
            <div class="multipoint-installation-pymes__container-select">
              <app-custom-select
                *ngIf="
                  !installationForm.get('feeReal').value || !hasTDOrTDVEString(installationForm.get('feeReal').value)
                "
                class="custom-select"
                [label]="'NEW_CONTRACTS.ACCESS_RATE'"
                [controlName]="'fee'"
                [values]="feeList"
                [required]="true"
                [requiredLabel]="!dataDraft?.previousInstallation?.chargeManual"
                [defaultValue]="installationForm.get('fee').value"
              ></app-custom-select>
              <mat-error *ngIf="checkControlRequired(installationForm.get('fee'))">
                {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
              </mat-error>
            </div>
            <div class="multipoint-installation-pymes__consumption-power">
              <div class="multipoint-installation-pymes__consumption-power-box">
                <h4 class="multipoint-installation-pymes__consumption-power-title">
                  {{ 'NEW_CONTRACTS.CONSUMPTION-POWER-INFO.CONSUMPTION' | i18nextEager }} (kWh)
                </h4>
                <div class="multipoint-installation-pymes__consumption-power-content">
                  <div
                    *ngFor="let consumption of [0, 1, 2, 3, 4, 5]"
                    class="multipoint-installation-pymes__consumption-power-period"
                  >
                    <p class="multipoint-installation-pymes__consumption-power-period-title">
                      {{ 'NEW_CONTRACTS.CONSUMPTION-POWER-INFO.P' | i18nextEager }}{{ consumption + 1 }}
                    </p>
                    <p class="multipoint-installation-pymes__consumption-power-period-value">
                      {{
                        installationForm?.get('estimatedConsumptionPeriod')?.value?.length > 0 &&
                        (installationForm?.get('estimatedConsumptionPeriod')?.value)[consumption] !== 0
                          ? ((installationForm?.get('estimatedConsumptionPeriod')?.value)[consumption] | number)
                          : ''
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="multipoint-installation-pymes__consumption-power-box">
                <h4 class="multipoint-installation-pymes__consumption-power-title">
                  {{ 'NEW_CONTRACTS.CONSUMPTION-POWER-INFO.POWER' | i18nextEager }} (kw)
                </h4>
                <div class="multipoint-installation-pymes__consumption-power-content">
                  <div
                    *ngFor="let power of [0, 1, 2, 3, 4, 5]"
                    class="multipoint-installation-pymes__consumption-power-period"
                  >
                    <p class="multipoint-installation-pymes__consumption-power-period-title">
                      {{ 'NEW_CONTRACTS.CONSUMPTION-POWER-INFO.P' | i18nextEager }}{{ power + 1 }}
                    </p>
                    <p class="multipoint-installation-pymes__consumption-power-period-value">
                      {{
                        installationForm?.get('contractedPowerPeriod')?.value?.length > 0
                          ? ((installationForm?.get('contractedPowerPeriod')?.value)[power] | number)
                          : ''
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!isUserSpanish">
            <div class="multipoint-installation-pymes__container-select">
              <app-custom-select
                *ngIf="!isUserSpanish"
                class="width100"
                [label]="'NEW_CONTRACTS.TENSION'"
                [controlName]="'tension'"
                [values]="repin[i] ? tensionList[i] : tensionNoRepinList"
                [defaultValue]="installationForm.get('tension').value"
                [disabled]="installationForm.get('tension').disabled"
                [required]="true"
                [requiredLabel]="true"
                (onChange)="onChangeTension(installationForm, $event, i)"
              >
              </app-custom-select>
              <mat-error *ngIf="checkControlRequired(installationForm.get('tension'))">
                {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
              </mat-error>
            </div>
            <app-custom-select
              *ngIf="!isUserSpanish"
              class="width100"
              [label]="'NEW_CONTRACTS.CYCLE'"
              [controlName]="'cycle'"
              [values]="cycleList[i]"
              [defaultValue]="installationForm.get('cycle').value"
              [disabled]="installationForm.get('cycle').disabled"
              [required]="true"
              [requiredLabel]="!dataDraft?.previousInstallation?.chargeManual"
              (onChange)="onChangeCycle(installationForm, $event, i)"
            ></app-custom-select>
            <app-custom-select
              *ngIf="!isUserSpanish"
              class="width100"
              [label]="'NEW_CONTRACTS.PERIOD'"
              [controlName]="'period'"
              [values]="periodList[i]"
              [defaultValue]="installationForm.get('period').value"
              [disabled]="installationForm.get('period').disabled"
              [required]="true"
              [requiredLabel]="!dataDraft?.previousInstallation?.chargeManual"
              (onChange)="onChangePeriod(installationForm, $event, i)"
            ></app-custom-select>
            <app-custom-select
              *ngIf="!isUserSpanish"
              class="width100"
              [label]="'NEW_CONTRACTS.POTENCY'"
              [controlName]="'potency'"
              [values]="potencyList[i]"
              [defaultValue]="installationForm.get('potency').value"
              [disabled]="installationForm.get('potency').disabled"
              [required]="true"
              [requiredLabel]="!dataDraft?.previousInstallation?.chargeManual"
              (onChange)="onChangePotency(installationForm, $event)"
            ></app-custom-select>
            <mat-form-field *ngIf="installationForm.get('potency').value === 'Otro'" appearance="outline">
              <mat-label>{{ 'NEW_CONTRACTS.CUSTOM_POTENCY' | i18nextEager }}</mat-label>
              <input
                matInput
                formControlName="customPotency"
                numberCustom
                [regex]="regexTwoDecimal"
                [formControl]="installationForm.get('customPotency')"
                [errorStateMatcher]="customErrorMatcher('required')"
              />
              <mat-error
                *ngIf="installationForm.get('customPotency').errors?.required &&
                (installationForm.get('customPotency')?.touched || installationForm.get('customPotency')?.dirty)"
              >
                {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
              </mat-error>
              <mat-error
                *ngIf="
                  installationForm.get('customPotency').errors?.pattern &&
                  (installationForm.get('customPotency').touched || installationForm.get('customPotency').dirty)
                "
              >
                {{ 'COMMONS.FORMAT_FIELD' | i18nextEager }}
              </mat-error>
              <mat-hint
                *ngIf="
                  checkControlMin(installationForm.get('customPotency'), i) &&
                  !installationForm.get('customPotency').errors?.pattern
                "
                class="hint-error"
              >
                {{ 'NEW_CONTRACTS.MIN_POTENCY' | i18nextEager }} {{ minPotency[i] }}
              </mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ 'NEW_CONTRACTS.CONSUMPTION_ANUAL' | i18nextEager }}
              </mat-label>
              <input
                matInput
                formControlName="consumptionEstimated"
                numberCustom
                [regex]="regexThreeDecimal"
                [formControl]="installationForm.get('consumptionEstimated')"
                [errorStateMatcher]="customErrorMatcher('required')"
              />
              <mat-error
                *ngIf="installationForm.get('consumptionEstimated').errors?.required"
              >
                {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
              </mat-error>
              <mat-error
                *ngIf="installationForm.get('consumptionEstimated').errors?.pattern"
              >
                {{ 'COMMONS.FORMAT_FIELD' | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </ng-container>

          <!-- Dirección de la Instalación -->
          <mat-expansion-panel>
            <mat-expansion-panel-header (click)="$event.stopPropagation()">
              <mat-panel-title>
                <span class="title">{{ 'NEW_CONTRACTS.INSTALLATION_DATA.ADDRESS_INSTALLATION' | i18nextEager }}</span>
                <img
                  *ngIf="installationAddressHaveError(installationForm, false)"
                  src="assets/icons/rejected-red.svg"
                  alt="{{ 'NEW_CONTRACTS.REJECTED' | i18nextEager }}"
                />
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="content">
              <div class="multipoint-installation-pymes__container-select">
                <app-custom-select
                  class="custom-select"
                  [required]="true"
                  [label]="'NEW_CONTRACTS.ROAD_TYPE'"
                  [controlName]="'addressRoadType'"
                  [values]="roadTypeList"
                  [defaultValue]="installationForm.get('addressRoadType').value"
                  [searchBar]="true"
                  [disabled]="installationForm.get('addressRoadType').disabled"
                  [requiredLabel]="true"
                >
                </app-custom-select>
                <mat-error *ngIf="checkControlRequired(installationForm.get('addressRoadType'))">
                  {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                </mat-error>
              </div>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.ROAD_NAME' | i18nextEager }}</mat-label>
                <input
                  matInput
                  formControlName="addressName"
                  maxlength="100"
                  [errorStateMatcher]="customErrorMatcher('required')"
                />
                <mat-error *ngIf="checkControlRequired(installationForm.get('addressName'))">
                  {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>

              <div class="tree-col" *ngIf="isUserSpanish">
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_NUMBER' | i18nextEager }}</mat-label>
                    <input matInput formControlName="addressNumber" maxlength="8" alphanumeric />
                    <mat-error
                      *ngIf="
                        installationForm?.get('addressNumber').errors?.maxlength &&
                        (installationForm?.get('addressNumber').touched || installationForm?.get('addressNumber').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.EIGHT_CHARACTERS_ERROR' | i18nextEager }}
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !installationForm?.get('addressNumber').errors?.maxlength &&
                        installationForm?.get('addressNumber').errors?.invalidInitialValue &&
                        (installationForm?.get('addressNumber').touched || installationForm?.get('addressNumber').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_GATE' | i18nextEager }}</mat-label>
                    <input matInput formControlName="addressGate" maxlength="10" />
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_STAIR' | i18nextEager }}</mat-label>
                    <input matInput formControlName="addressStair" maxlength="3" alphanumeric />
                    <mat-error
                      *ngIf="
                        installationForm?.get('addressStair').errors?.maxlength &&
                        (installationForm?.get('addressStair').touched || installationForm?.get('addressStair').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !installationForm?.get('addressStair').errors?.maxlength &&
                        installationForm?.get('addressStair').errors?.invalidInitialValue &&
                        (installationForm?.get('addressStair').touched || installationForm?.get('addressStair').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="tree-col">
                <div class="col" *ngIf="isUserSpanish">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_FLOOR' | i18nextEager }}</mat-label>
                    <input matInput formControlName="addressFloor" maxlength="3" alphanumeric />
                    <mat-error
                      *ngIf="
                        installationForm?.get('addressFloor').errors?.maxlength &&
                        (installationForm?.get('addressFloor').touched || installationForm?.get('addressFloor').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !installationForm?.get('addressFloor').errors?.maxlength &&
                        installationForm?.get('addressFloor').errors?.invalidInitialValue &&
                        (installationForm?.get('addressFloor').touched || installationForm?.get('addressFloor').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col" *ngIf="isUserSpanish">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_DOOR' | i18nextEager }}</mat-label>
                    <input matInput formControlName="addressDoor" maxlength="3" alphanumeric />
                    <mat-error
                      *ngIf="
                        installationForm?.get('addressDoor').errors?.maxlength &&
                        (installationForm?.get('addressDoor').touched || installationForm?.get('addressDoor').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !installationForm?.get('addressDoor').errors?.maxlength &&
                        installationForm?.get('addressDoor').errors?.invalidInitialValue &&
                        (installationForm?.get('addressDoor').touched || installationForm?.get('addressDoor').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field *ngIf="isUserSpanish" appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</mat-label>
                    <input
                      matInput
                      formControlName="addressPostalCode"
                      maxlength="5"
                      [errorStateMatcher]="customErrorMatcher('required')"
                    />
                    <mat-error *ngIf="checkControlRequired(installationForm.get('addressPostalCode'))">
                      {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <div *ngIf="!isUserSpanish">
                    <div class="multipoint-installation-pymes__pt-postal-code-field">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</mat-label>
                        <input matInput formControlName="addressPostalCodePT1" maxlength="4" [errorStateMatcher]="customErrorMatcher('required')"/>
                      </mat-form-field>
                      <p class="multipoint-installation-pymes__postal-code-hyphen">
                        {{ 'NEW_CONTRACTS.POSTAL_CODE_PT_HYPHEN' | i18nextEager }}
                      </p>
                      <mat-form-field appearance="outline">
                        <input matInput formControlName="addressPostalCodePT2" maxlength="3" />
                      </mat-form-field>
                    </div>
                    <mat-error
                      *ngIf="
                        (installationForm?.controls.addressPostalCodePT1.errors?.required ||
                          installationForm?.controls.addressPostalCodePT2.errors?.required)
                      "
                      class="multipoint-installation-pymes__pt-postal-code-error"
                    >
                      {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !installationForm?.controls.addressPostalCodePT1.errors?.required &&
                        !installationForm?.controls.addressPostalCodePT2.errors?.required &&
                        installationForm?.controls.addressPostalCode.errors?.pattern
                      "
                      class="multipoint-installation-pymes__pt-postal-code-error"
                    >
                      {{ 'NEW_CONTRACTS.POSTAL_CODE_ERROR' | i18nextEager }}
                    </mat-error>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="townAddressList[i]?.length <= 1; else selectTemplateAddressTown">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'NEW_CONTRACTS.TOWN' | i18nextEager }}</mat-label>
                  <input
                    matInput
                    formControlName="addressTown"
                    maxlength="100"
                    [errorStateMatcher]="customErrorMatcher('required')"
                  />
                </mat-form-field>
              </ng-container>

              <ng-template #selectTemplateAddressTown>
                <div class="multipoint-installation-pymes__container-select">
                  <app-custom-select
                    class="custom-select"
                    [label]="'NEW_CONTRACTS.TOWN'"
                    [controlName]="'addressTown'"
                    [values]="townAddressList[i]"
                    [required]="true"
                    [defaultValue]="installationForm.get('addressTown').value"
                    [disabled]="installationForm.get('addressTown').disabled"
                    [requiredLabel]="!dataDraft?.previousInstallation?.chargeManual"
                  >
                  </app-custom-select>
                  <mat-error *ngIf="checkControlRequired(installationForm.get('addressTown'))">
                    {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                  </mat-error>
                </div>
              </ng-template>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.PROVINCE' | i18nextEager }}</mat-label>
                <input
                  matInput
                  formControlName="addressProvince"
                  maxlength="100"
                  placeholder="{{ 'NEW_CONTRACTS.PROVINCE_EXAMPLE' | i18nextEager }}"
                  [errorStateMatcher]="customErrorMatcher('required')"
                />

                <mat-error *ngIf="checkControlRequired(installationForm.get('addressProvince'))">
                  {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>
            </div>
          </mat-expansion-panel>

          <!-- Dirección de notificación -->
          <mat-expansion-panel>
            <mat-expansion-panel-header (click)="$event.stopPropagation()">
              <mat-panel-title>
                <span class="title">{{ 'NEW_CONTRACTS.NOTIFICATION_ADDRESS' | i18nextEager }}</span>
                <img
                  *ngIf="installationAddressHaveError(installationForm, true)"
                  src="assets/icons/rejected-red.svg"
                  alt="{{ 'NEW_CONTRACTS.REJECTED' | i18nextEager }}"
                />
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="content">
              <div class="multipoint-installation-pymes__container-select">
                <app-custom-select
                  class="custom-select"
                  [required]="true"
                  [label]="'NEW_CONTRACTS.ROAD_TYPE'"
                  [controlName]="'addressNotifRoadType'"
                  [values]="roadTypeList"
                  [defaultValue]="installationForm.get('addressNotifRoadType').value"
                  [searchBar]="true"
                  [disabled]="installationForm.get('addressNotifRoadType').disabled"
                  [requiredLabel]="true"
                ></app-custom-select>
                <mat-error *ngIf="checkControlRequired(installationForm.get('addressNotifRoadType'))">
                  {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                </mat-error>
              </div>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.ROAD_NAME' | i18nextEager }}</mat-label>
                <input
                  matInput
                  formControlName="addressNotifName"
                  maxlength="100"
                  [errorStateMatcher]="customErrorMatcher('required')"
                />
                <mat-error *ngIf="checkControlRequired(installationForm.get('addressNotifName'))">
                  {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>

              <div class="tree-col" *ngIf="isUserSpanish">
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_NUMBER' | i18nextEager }}</mat-label>
                    <input matInput formControlName="addressNotifNumber" maxlength="8" alphanumeric />
                    <mat-error
                      *ngIf="
                        installationForm?.get('addressNotifNumber').errors?.maxlength &&
                        (installationForm?.get('addressNotifNumber').touched || installationForm?.get('addressNotifNumber').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.EIGHT_CHARACTERS_ERROR' | i18nextEager }}
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !installationForm?.get('addressNotifNumber').errors?.maxlength &&
                        installationForm?.get('addressNotifNumber').errors?.invalidInitialValue &&
                        (installationForm?.get('addressNotifNumber').touched || installationForm?.get('addressNotifNumber').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_GATE' | i18nextEager }}</mat-label>
                    <input matInput formControlName="addressNotifGate" maxlength="10" />
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_STAIR' | i18nextEager }}</mat-label>
                    <input matInput formControlName="addressNotifStair" maxlength="3" alphanumeric />
                    <mat-error
                      *ngIf="
                        installationForm?.get('addressNotifStair').errors?.maxlength &&
                        (installationForm?.get('addressNotifStair').touched || installationForm?.get('addressNotifStair').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !installationForm?.get('addressNotifStair').errors?.maxlength &&
                        installationForm?.get('addressNotifStair').errors?.invalidInitialValue &&
                        (installationForm?.get('addressNotifStair').touched || installationForm?.get('addressNotifStair').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="tree-col">
                <div class="col" *ngIf="isUserSpanish">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_FLOOR' | i18nextEager }}</mat-label>
                    <input matInput formControlName="addressNotifFloor" maxlength="3" alphanumeric />
                    <mat-error
                      *ngIf="
                        installationForm?.get('addressNotifFloor').errors?.maxlength &&
                        (installationForm?.get('addressNotifFloor').touched || installationForm?.get('addressNotifFloor').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !installationForm?.get('addressNotifFloor').errors?.maxlength &&
                        installationForm?.get('addressNotifFloor').errors?.invalidInitialValue &&
                        (installationForm?.get('addressNotifFloor').touched || installationForm?.get('addressNotifFloor').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col" *ngIf="isUserSpanish">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_DOOR' | i18nextEager }}</mat-label>
                    <input matInput formControlName="addressNotifDoor" maxlength="3" alphanumeric />
                    <mat-error
                      *ngIf="
                        installationForm?.get('addressNotifDoor').errors?.maxlength &&
                        (installationForm?.get('addressNotifDoor').touched || installationForm?.get('addressNotifDoor').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !installationForm?.get('addressNotifDoor').errors?.maxlength &&
                        installationForm?.get('addressNotifDoor').errors?.invalidInitialValue &&
                        (installationForm?.get('addressNotifDoor').touched || installationForm?.get('addressNotifDoor').dirty)
                      "
                    >
                      {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field *ngIf="isUserSpanish" appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</mat-label>
                    <input
                      matInput
                      formControlName="addressNotifPostalCode"
                      maxlength="5"
                      [errorStateMatcher]="customErrorMatcher('required')"
                    />
                    <mat-error *ngIf="checkControlRequired(installationForm.get('addressNotifPostalCode'))">
                      {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <div *ngIf="!isUserSpanish">
                    <div class="multipoint-installation-pymes__pt-postal-code-field">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</mat-label>
                        <input matInput formControlName="addressNotifPostalCodePT1" maxlength="4" [errorStateMatcher]="customErrorMatcher('required')"/>
                      </mat-form-field>
                      <p class="multipoint-installation-pymes__postal-code-hyphen">
                        {{ 'NEW_CONTRACTS.POSTAL_CODE_PT_HYPHEN' | i18nextEager }}
                      </p>
                      <mat-form-field appearance="outline">
                        <input matInput formControlName="addressNotifPostalCodePT2" maxlength="3" />
                      </mat-form-field>
                    </div>
                    <mat-error
                      *ngIf="
                        (installationForm?.controls.addressNotifPostalCodePT1.errors?.required ||
                          installationForm?.controls.addressNotifPostalCodePT2.errors?.required)
                      "
                      class="multipoint-installation-pymes__pt-postal-code-error"
                    >
                      {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !installationForm?.controls.addressNotifPostalCodePT1.errors?.required &&
                        !installationForm?.controls.addressNotifPostalCodePT2.errors?.required &&
                        installationForm?.controls.addressNotifPostalCode.errors?.pattern
                      "
                      class="multipoint-installation-pymes__pt-postal-code-error"
                    >
                      {{ 'NEW_CONTRACTS.POSTAL_CODE_ERROR' | i18nextEager }}
                    </mat-error>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="townAddressNotifList[i]?.length <= 1; else selectTemplateAddressNotifTown">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'NEW_CONTRACTS.TOWN' | i18nextEager }}</mat-label>
                  <input
                    matInput
                    formControlName="addressNotifTown"
                    maxlength="100"
                    [errorStateMatcher]="customErrorMatcher('required')"
                  />
                </mat-form-field>
              </ng-container>

              <ng-template #selectTemplateAddressNotifTown>
                <div class="multipoint-installation-pymes__container-select">
                  <app-custom-select
                    class="custom-select"
                    [label]="'NEW_CONTRACTS.TOWN'"
                    [controlName]="'addressNotifTown'"
                    [values]="townAddressNotifList[i]"
                    [required]="true"
                    [defaultValue]="installationForm.get('addressNotifTown').value"
                    [disabled]="installationForm.get('addressNotifTown').disabled"
                    [requiredLabel]="!dataDraft?.previousInstallation?.chargeManual"
                  >
                  </app-custom-select>
                  <mat-error *ngIf="checkControlRequired(installationForm.get('addressNotifTown'))">
                    {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                  </mat-error>
                </div>
              </ng-template>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.PROVINCE' | i18nextEager }}</mat-label>
                <input
                  matInput
                  formControlName="addressNotifProvince"
                  maxlength="100"
                  placeholder="{{ 'NEW_CONTRACTS.PROVINCE_EXAMPLE' | i18nextEager }}"
                  [errorStateMatcher]="customErrorMatcher('required')"
                />

                <mat-error *ngIf="checkControlRequired(installationForm.get('addressNotifProvince'))">
                  {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>
            </div>
          </mat-expansion-panel>

          <!-- Persona de contacto -->
          <mat-expansion-panel>
            <mat-expansion-panel-header (click)="$event.stopPropagation()">
              <mat-panel-title>
                <span class="title">{{ 'NEW_CONTRACTS.CONTACT' | i18nextEager }}</span>
                <img
                  *ngIf="installationContactHaveError(installationForm)"
                  src="assets/icons/rejected-red.svg"
                  alt="{{ 'NEW_CONTRACTS.REJECTED' | i18nextEager }}"
                />
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="content">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.NAME' | i18nextEager }}</mat-label>
                <input
                  matInput
                  formControlName="contactName"
                  maxlength="50"
                  [errorStateMatcher]="customErrorMatcher('required')"
                />
                <mat-error *ngIf="checkControlRequired(installationForm.get('contactName'))">
                  {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.SURNAME' | i18nextEager }}</mat-label>
                <input
                  matInput
                  formControlName="contactSurname"
                  maxlength="50"
                  [errorStateMatcher]="customErrorMatcher('required')"
                />
                <mat-error *ngIf="checkControlRequired(installationForm.get('contactSurname'))">
                  {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.DNI_NIE' | i18nextEager }}</mat-label>
                <input
                  matInput
                  formControlName="contactDocumentNumber"
                  maxlength="9"
                  placeholder="{{ isUserSpanish ? ('NEW_CONTRACTS.DNI_EXAMPLE' | i18nextEager) : '' }}"
                  [errorStateMatcher]="customErrorMatcher('dni')"
                />
                <mat-error *ngIf="checkControlRequired(installationForm.get('contactDocumentNumber'))">
                  {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                </mat-error>
                <mat-error *ngIf="checkControlDni(installationForm.get('contactDocumentNumber'))">
                  {{ 'NEW_CONTRACTS.DNI_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.EMAIL' | i18nextEager }}</mat-label>
                <input
                  matInput
                  formControlName="contactEmail"
                  placeholder="{{ 'NEW_CONTRACTS.EMAIL_EXAMPLE' | i18nextEager }}"
                  maxlength="50"
                  [errorStateMatcher]="customErrorMatcher('email')"
                />
                <mat-error *ngIf="checkControlRequired(installationForm.get('contactEmail'))">
                  {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                </mat-error>
                <mat-error *ngIf="checkControlEmail(installationForm.get('contactEmail'))">
                  {{ 'NEW_CONTRACTS.EMAIL_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>

              <div class="multipoint-installation-pymes__mobile-field">
                <div *ngIf="!isUserSpanish" class="multipoint-installation-pymes__country-code">
                  <app-custom-select
                    [required]="true"
                    [label]="'NEW_CONTRACTS.MOBILE_COUNTRY_CODE.LABEL'"
                    [controlName]="'contactMobileCountryCode'"
                    [values]="contactMobileCountryCodeList"
                    [disabled]="installationForm.get('contactMobileCountryCode').disabled"
                    [defaultValue]="installationForm.get('contactMobileCountryCode').value"
                    [requiredLabel]="true"
                  ></app-custom-select>
                  <mat-error *ngIf="checkControlRequired(installationForm.get('contactMobileCountryCode'))">
                    {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                  </mat-error>
                </div>
                <div class="multipoint-installation-pymes__mobile-input">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.MOBILE' | i18nextEager }}</mat-label>
                    <input
                      matInput
                      formControlName="contactMobile"
                      maxlength="9"
                      numeric
                      [errorStateMatcher]="customErrorMatcher('mobile')"
                    />
                    <mat-error *ngIf="checkControlRequired(installationForm.get('contactMobile'))">
                      {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                    </mat-error>
                    <mat-error *ngIf="checkControlMobile(installationForm.get('contactMobile'))">
                      {{ 'NEW_CONTRACTS.MOBILE_ERROR' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- Cuenta bancaria -->
          <mat-expansion-panel *ngIf="isUserSpanish">
            <mat-expansion-panel-header (click)="$event.stopPropagation()">
              <mat-panel-title>
                <span class="title">{{ 'NEW_CONTRACTS.BANK_ACCOUNT' | i18nextEager }} *</span>
                <img
                  *ngIf="installationIbanHaveError(installationForm)"
                  src="assets/icons/rejected-red.svg"
                  alt="{{ 'NEW_CONTRACTS.REJECTED' | i18nextEager }}"
                />
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="content account">
              <mat-form-field appearance="outline" id="ibanCode">
                <mat-label>{{ 'NEW_CONTRACTS.IBAN' | i18nextEager }}</mat-label>
                <input
                  matInput
                  uppercase
                  id="{{ 'ibanInput' + i }}"
                  formControlName="ibanCode"
                  maxlength="4"
                  [errorStateMatcher]="customErrorMatcher('iban')"
                  (paste)="onPasteIBAN($event, i)"
                  (keyup)="bankAccountKeyUp($event, null, 'ibanInput', 'entityInput', i)"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" id="ibanEntity">
                <mat-label>{{ 'NEW_CONTRACTS.ENTITY' | i18nextEager }}</mat-label>
                <input
                  matInput
                  numeric
                  id="{{ 'entityInput' + i }}"
                  formControlName="ibanEntity"
                  maxlength="4"
                  [errorStateMatcher]="customErrorMatcher('iban')"
                  (paste)="onPasteIBAN($event, i)"
                  (keyup)="bankAccountKeyUp($event, 'ibanInput', 'entityInput', 'officeInput', i)"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" id="ibanOffice">
                <mat-label>{{ 'NEW_CONTRACTS.OFFICE' | i18nextEager }}</mat-label>
                <input
                  matInput
                  numeric
                  id="{{ 'officeInput' + i }}"
                  formControlName="ibanOffice"
                  maxlength="4"
                  [errorStateMatcher]="customErrorMatcher('iban')"
                  (paste)="onPasteIBAN($event, i)"
                  (keyup)="
                    bankAccountKeyUp(
                      $event,
                      'entityInput',
                      'officeInput',
                      'dcInput',
                      i
                    )
                  "
                />
              </mat-form-field>
              <mat-form-field appearance="outline" id="ibanDC">
                <mat-label>{{ 'NEW_CONTRACTS.DC' | i18nextEager }}</mat-label>
                <input
                  matInput
                  numeric
                  id="{{ 'dcInput' + i }}"
                  formControlName="ibanDC"
                  maxlength="2"
                  [errorStateMatcher]="customErrorMatcher('iban')"
                  (paste)="onPasteIBAN($event, i)"
                  (keyup)="bankAccountKeyUp($event, 'officeInput', 'dcInput', 'accountInput', i)"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" id="ibanAccount">
                <mat-label>{{ 'NEW_CONTRACTS.ACCOUNT' | i18nextEager }}</mat-label>
                <input
                  matInput
                  numeric
                  id="{{ 'accountInput' + i }}"
                  formControlName="ibanAccount"
                  [maxlength]="10"
                  [errorStateMatcher]="customErrorMatcher('iban')"
                  (paste)="onPasteIBAN($event, i)"
                  (keyup)="
                    bankAccountKeyUp(
                      $event,
                      'dcInput',
                      'accountInput',
                      null,
                      i
                    )
                  "
                />
              </mat-form-field>
            </div>
            <mat-error
              class="account__error"
              *ngIf="
                checkControlRequired(installationForm.get('ibanCode')) &&
                checkControlRequired(installationForm.get('ibanEntity')) &&
                checkControlRequired(installationForm.get('ibanOffice')) &&
                checkControlRequired(installationForm.get('ibanDC')) &&
                checkControlRequired(installationForm.get('ibanAccount'))
              "
            >
              {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error class="account__error" *ngIf="checkControlIban(installationForm)">
              {{ 'NEW_CONTRACTS.IBAN_ERROR' | i18nextEager }}
            </mat-error>
          </mat-expansion-panel>
        </section>
      </ng-container>
      <button class="addSelector secondary" mat-button (click)="handleAddInstallation()">
        {{ 'NEW_CONTRACTS.INSTALLATION_DATA.ADD_INSTALLATION' | i18nextEager }}
      </button>
    </ng-container>
  </form>
</div>
